import type { Id } from '@hq/utils';
import { toQuery, type HttpClient } from '../client';
import type {
  OrgGroupDeleteResult,
  OrgGroupQuery,
  OrgGroupRow,
  OrgGroupSaveRequest,
  OrgGroupSaveResult
} from '../types/orgGroup';

const BASE = '/sys/org-group';

/**
 * 医共体 / 集团（`org_group`）：统招分签与集团采购的归口单位，
 * 机构通过 `org_institution.group_id` 挂靠。
 */
export function createOrgGroupApi(http: HttpClient) {
  return {
    list(query: OrgGroupQuery = {}): Promise<OrgGroupRow[]> {
      return http.request<OrgGroupRow[]>({ path: BASE, query: toQuery(query) });
    },

    /** 新增（id 为空）或更新。 */
    save(body: OrgGroupSaveRequest): Promise<OrgGroupSaveResult> {
      return http.request<OrgGroupSaveResult>({ path: BASE, method: 'POST', body });
    },

    /** 逻辑删除：仍有机构挂靠时后端会拒绝。 */
    remove(id: Id): Promise<OrgGroupDeleteResult> {
      return http.request<OrgGroupDeleteResult>({ path: `${BASE}/${id}`, method: 'DELETE' });
    }
  };
}

export type OrgGroupApi = ReturnType<typeof createOrgGroupApi>;
